"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTable = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledTable = _styledComponents["default"].table.withConfig({
  displayName: "Tablestyles__StyledTable",
  componentId: "sc-pkn6ab-0"
})(["border-collapse:collapse;", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    w-100\n    ", "\n  "])), function (_ref) {
  var table = _ref.theme.table;
  return table.typography;
}));

exports.StyledTable = StyledTable;